import { ApiError, useApiClient, useAsyncCache, useTranslation } from '@msdk/common'
import { ListValue, StringValue } from '@msdk/definitions'
import { FieldProps, useEntityFromCollection } from '@msdk/forms'
import { styled, Typography } from '@msdk/ui'
import React, { useEffect, useState } from 'react'

import { EntityNumericFields, NumericItem } from '../../../ClientCustomLogics'

const TitleWrapper = styled('div')`
  margin-top: 25px;
  margin-bottom: 10px;
`
export function MuDecimalPlaces({ node }: FieldProps) {
  const t = useTranslation()
  const label: string = t('LBL_MEASUREMENT_UNIT_DECIMAL_PLACES', 'Decimal places')

  const cache = useAsyncCache()

  const client = useApiClient()
  const [allFieldsFromMetadata, setAllFieldsFromMetadata] = useState<EntityNumericFields[]>([])
  const entityContext = useEntityFromCollection(node.value.entityId as string)

  useEffect(() => {
    const fetch = async () => {
      const res = await cache.getOrCreate('MU_NUMERIC_FIELDS_LIST', () =>
        client.read<EntityNumericFields[]>('CMPS/api/composer/basemetadatawithnumerics'),
      )
      if (res instanceof ApiError) {
        return
      }

      setAllFieldsFromMetadata(res)
    }
    fetch()
  }, [])

  const fieldName = (entityContext?.fields['MEASUREMENT_UNIT_FIELD_NAME'] as StringValue)?.value
  const entityName = (entityContext?.fields['METADATA_LIST'] as ListValue)?.value?.[0]?.fields['ENTITY_NAME']?.value
  const format = (
    allFieldsFromMetadata
      .find((i) => i.entity.name === entityName)
      ?.numericFields.find((f) => f.name === fieldName) as NumericItem
  )?.format

  return (
    <>
      <TitleWrapper>
        <Typography variant="body1" fontWeight="bold">
          {label}:
        </Typography>
      </TitleWrapper>
      <Typography variant="body1">{format}</Typography>
    </>
  )
}
